import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ces-first-fit',
  templateUrl: './ces-first-fit.component.html',
  styleUrls: ['./ces-first-fit.component.scss']
})
export class CesFirstFitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
